import axios from 'src/utils/axios';

const v3_actionGetChannelHealth = (clienteId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.periodo) queryParams.append('periodo', params.periodo);

    const queryString = queryParams.toString();
    return axios.get(`/v3/chats/health/${clienteId}${queryString ? `?${queryString}` : ''}`);
};

export default v3_actionGetChannelHealth;
